// extracted by mini-css-extract-plugin
module.exports = {"component":"Banner_component__2gvmq"};